
import { get, post } from "../utils/api";

export const groupCart = (data) => {
    return get(`/group-cart?page=${data.page || 1}&limit=${data.limit || 10}`);
};
export const groupCartCreate = (values) => {
    return post(`/group-cart`, values);
};
export const addItemsApi = (values) => {
    return post(`/group-cart/add-items`, values);
};
export const groupCartSingle = (id) => {
    return get(`/group-cart/${id}`);
};
export const unassignedItems = (id) => {
    return get(`/group-cart/items/unassigned`);
};
export const inviteMember = (values) => {
    return post(`/group-cart/invite-members`, values);
};
export const groupCartApi = {
    groupCart,
    groupCartCreate,
    groupCartSingle,
    unassignedItems,
    addItemsApi,
    inviteMember
};
